import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import EvaluationStatusForm from '../../../components/forms/EvaluationStatusForm';
import { useEvaluationStatusApi } from '../../../hooks/useEvaluationStatusApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { EvaluationStatusDTO } from '../../../services/apiClient';

const EvaluationStatusEdit: React.FC = () => {
  const { getById, edit, isLoading } = useEvaluationStatusApi();
  const [entityData, setEntityData] = useState<EvaluationStatusDTO | null>(
    null,
  );
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Evaluation Statuses', href: '/admin/evaluationstatuses' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching EvaluationStatus data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(id!, data);
      navigate('/admin/evaluationstatuses');
    } catch (error) {
      console.error('Error updating EvaluationStatus:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/evaluationstatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.EvaluationStatus.Edit"
    >
        {entityData ? (
          <EvaluationStatusForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/evaluationstatuses')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default EvaluationStatusEdit;
